module.exports = __webpack_public_path__ + "img/102-b-04.prt.8fdf0795.jpg";